import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import CheckoutDetails from "../../components/checkoutDetails/CheckoutDetails";
import PaymentMethods from "../../components/PaymentMethods";
import PaypalPage from "../../components/PaypalPage";
import { Container, Row, Col } from "react-bootstrap";
import { UUIDContext } from "../../UUIDContexted";
import CONSTANTS from "../../utils/constants";

import "./paymentMethods.css";

const Paypal: React.FC = () => {
  const PBLData = useContext(UUIDContext);

  return (
    <Container fluid className="d-flex payment-method" data-testid="parentContainer">
      <Row className="w-100 mobile-column-reverse g-0">
        <Col xs={12} lg={6} className="paymentMethods-wrapper" data-testid="info-paymentmethods">
          <PaymentMethods choosenMethod={'paypal'}/>
          <PaypalPage />
        </Col>

        <Col className="d-none d-lg-block" style={{flex: 1}}></Col> {/* Spacer div for in-between column */}

        <Col xs={12} lg={5} id="checkout-details" className="checkout-details flex-column" data-testid="info-checkoutDetails">
          <div className="mobile-page-heading d-block d-lg-none">
            <span>
              <span className="mobile-page-heading-span3">
              <FormattedMessage
                  id={CONSTANTS.PAYMENT_METHODS.PAGE_HEADING}
                  defaultMessage="Payment-link"
                />
                <br />
              </span>
              <span className="mobile-page-heading-span4">
                <FormattedMessage
                  id={CONSTANTS.PAYMENT_METHODS.SUB_PAGE_HEADING}
                  defaultMessage="Checkout"
                />
                </span>
            </span>
          </div>
          {PBLData && PBLData.items && PBLData.amountOfMoney ?
            <CheckoutDetails CheckoutDetailsData={{ items: PBLData.items, amountOfMoney: PBLData.amountOfMoney }} />
            : <div><b><FormattedMessage id={CONSTANTS.NO_DATA_AVAILABLE} defaultMessage="No Data Available" /></b></div>
          }
        </Col>
      </Row>
    </Container>
  );
};

export default React.memo(Paypal);
